import { TNoticeType } from 'store/features/application/types/notice';

type INoticeTypes = {
  [key in TNoticeType]: key;
};

export const NOTICE_TYPES: INoticeTypes = {
  error: 'error',
  warning: 'warning',
  success: 'success',
};
